/* @flow */

import * as React from 'react';

import type { VenueResult } from 'search/types';

type Props = {
  venue: VenueResult,
  openInNewTab?: boolean,
  className?: string,
  children: React.Node
};

export default function VenueLink(props: Props) {
  const { openInNewTab = false, venue, className } = props;
  const linkTarget = openInNewTab ? `venue_${venue.id}` : '_self';

  return (
    <a href={venue.url} target={linkTarget} className={className}>
      {props.children}
    </a>
  );
}
